export default "__VITE_ASSET__CkrIPs1t__"